import fetch from "cross-fetch";

export type ZefixCompany = {
    name: string;
    ehraid: number;
    uid: string;
    uidFormatted: string;
    chid: string;
    chidFormatted: string;
    legalSeatId: number;
    legalSeat: string; // i.e. Lausanne
    registerOfficeId: number;
    legalFormId: number;
    status: string;
};

type ZefixSearchResult = {
    list: ZefixCompany[];
    maxEntries: number;
    hasMoreResults: boolean;
    offset: number;
    maxOffset: number;
};

export const searchCompany = async (q: string, lang: string): Promise<ZefixCompany[]> => {
    const response = await fetch("https://www.zefix.ch/ZefixREST/api/v1/firm/search.json", {
        method: "POST",
        headers: {
            "content-type": "application/json;charset=UTF-8",
        },
        body: JSON.stringify({
            languageKey: lang,
            maxEntries: 30,
            name: q,
            offset: 0,
        }),
    });
    if (response.status === 404) {
        return [];
    }
    if (!response.ok) {
        throw new Error(`Error fetching companies from Zefix API ${response.status}`);
    }
    const ret = (await response.json()) as ZefixSearchResult;
    return ret.list;
};
